import { css as r } from "@microsoft/fast-element";
import { normalize as i } from "../common/normalize.js";
import { display as a } from "@matrix42/fast-foundation";
import { designTokens as t } from "../design-tokens.js";
const c = (e) => r`
  ${i}
  ${a("flex")}
  :host(.checkbox-selection) ${e.prefix}-trow ${e.prefix}-tcell:first-child {
    /* Base */
    width: ${t.spacing[10]} !important;
    vertical-align: middle;
    line-height: 0;
    /* Layout */
    padding: ${t.spacing[3]};
  }

  .control {
    /* Base */
    width: 100%;
  }

  ${e.prefix}-thead ${e.prefix}-tcell {
    /* Base */
    user-select: none;
  }

  ${e.prefix}-thead ${e.prefix}-tcell[data-sortable] {
    /* Base */
    cursor: pointer;
  }

  ${e.prefix}-thead ${e.prefix}-icon.sort-icon {
    /* Base */
    vertical-align: top;
    /* Style */
    color: ${t.color.neutral[400]};
  }

  ${e.prefix}-thead ${e.prefix}-tcell[data-sort] ${e.prefix}-icon.sort-icon {
    /* Style */
    color: ${t.color.primary[100]};
  }

  .title {
    /* Base */
    vertical-align: top;
  }

  .footer {
    /* Layout */
    display: flex;
    padding-top: ${t.spacing[4]};
    align-items: center;
    justify-content: center;
  }
`;
export {
  c as dataGridStyles
};
